// src/lib/firebaseClient.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDhLvMn-y2lB6SscZAAau2u_el_LgCCcGI",
  authDomain: "shtbx-leaderboard.firebaseapp.com",
  databaseURL: "https://shtbx-leaderboard-default-rtdb.firebaseio.com",
  projectId: "shtbx-leaderboard",
  storageBucket: "shtbx-leaderboard.appspot.com", // use the exact value from console if different
  messagingSenderId: "1089722167335",
  appId: "1:1089722167335:web:7e16437e02786a0ca35e02",
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const rtdb = getDatabase(app);
